import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ActionButtonsProps {
  onSave: () => void;
  onClone: () => void;
  onReset: () => void;
  isSaving: boolean;
  isLoading?: boolean;
}

const ActionButtons = ({ onSave, onClone, onReset, isSaving, isLoading }: ActionButtonsProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Button onClick={onSave} disabled={isSaving || isLoading} className="w-full" size="lg">
        {isSaving ? (
          <>
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            Saving...
          </>
        ) : (
          <>
            <Save className="h-4 w-4 mr-2" />
            Save Configuration
          </>
        )}
      </Button>
      <Button onClick={onClone} variant="outline" className="w-full" size="lg">
        Clone from Default
      </Button>
      <Button onClick={onReset} variant="outline" className="w-full" size="lg">
        Reset to Defaults
      </Button>
    </div>
  );
};

export default ActionButtons;
